import React, { useEffect, useRef, useState } from "react";
import ManualDocumentsVATReturnsLineEditor from "../filing/manualDocuments/ManualDocumentsVATReturnsLineEditor";
import { connect } from "react-redux";
import MANUAL_DOCUMENTS_CONTROLLER from '../../controllers/manualDocuments';
import LanguageStringResolver from "../fields/language/LanguageStringResolver";
import _ from "underscore";
import { VATBoxType, ReturnPeriodTimeType } from '../../utils/enums';
import { getEnumBy } from '../helper/ReactComponentHelper';

const EnhancedVATReturns = (props) => {
    const [selectedValues, setSelectedValues] = useState({
        totalTaxableBasis: 0,
        totalVAT: 0,
        vatBoxes: []
    });
    const vatReturnsEditorRef = useRef(null);

    useEffect(() => {
        fetchVatBoxes();
    }, [props.selectedValues?.companyCode, props.selectedValues?.country, props.selectedValues?.transactionDate]);

    const convertVatBoxes = () => {
        const vatBoxes = _.isArray(selectedValues?.vatBoxes) ? selectedValues?.vatBoxes.map((vatBox) => {
            const boxValue = Number.parseFloat(vatBox.boxValue);
            const vatBoxTypeEnum = getEnumBy(VATBoxType, vatBox.boxType, props.languages) || {};
            const returnTypeEnum = getEnumBy(ReturnPeriodTimeType, vatBox.returnType, props.languages) || {};
            return {
                boxName: vatBox.boxName,
                boxType: vatBoxTypeEnum.value,
                boxValue: Number.isNaN(boxValue) ? 0 : boxValue,
                returnType: returnTypeEnum.value
            };
        }) : [];

        return vatBoxes;
    }

    const handleClearVatBoxList = () => {
        if (vatReturnsEditorRef.current) {
            const comp = vatReturnsEditorRef.current.getWrappedInstance();
            comp.clearVatBoxList();
        }
    }

    const handleSubmit = () => {
        const vatBoxes = convertVatBoxes();
        let payload = {
            filingType: 1,
            companyCode: props.selectedValues?.companyCode,
            country: props.selectedValues?.country,
            transactionDate: props.selectedValues?.transactionDate,
            invoiceDate: props.selectedValues?.invoiceDate,
            reporterName: props.selectedValues?.reporterName,
            referenceCode: props.selectedValues?.referenceCode,
            currency: props.selectedValues?.currency,
            documentType: props.selectedValues?.documentType === "SALES" ? 0 : 1,
            countryMainTransaction: props.selectedValues?.country,
            vatBoxes,
            totalTaxableBasis: Number(selectedValues.totalTaxableBasis),
            totalVAT: Number(selectedValues.totalVAT),
        }
        props.doCreateManualDocumentLatest(payload);
        handleClearVatBoxList();
        setSelectedValues({
            ...selectedValues,
            vatBoxes: []
        });
    };

    const handleInputChange = (selection) => {
        setSelectedValues({
            ...selectedValues,
            ...selection
        });
    };

    const handleVatBoxClick = (vatBoxList) => {
        setSelectedValues({
            ...selectedValues,
            vatBoxes: vatBoxList
        });
    };

    const fetchVatBoxes = () => {
        const params = {
            countryCode: props?.selectedValues?.country,
            companyId: props?.selectedValues?.companyCode,
            onDate: props?.selectedValues?.transactionDate,
        };
        props.doLoadVATBoxes(params);
    }

    return (
        <>
            <ManualDocumentsVATReturnsLineEditor
                hideTitle={true}
                vatBoxes={props.vatBoxes}
                onAddClick={handleVatBoxClick}
                onRemoveClick={handleVatBoxClick}
                onInputChange={handleInputChange}
                ref={vatReturnsEditorRef}
            />
            <div className='mt15'>
                <button data-testid='submit-button' className='primary' type='submit' onClick={handleSubmit} disabled={!selectedValues?.vatBoxes?.length}>
                    <LanguageStringResolver string='manualDocumentsForm_Submit' />
                </button>
            </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    vatBoxes: state.manualDocuments?.vatBoxes,
    languages: state.languages,
});

const mapDispatchToProps = (dispatch) => ({
    doLoadVATBoxes: (params) => {
        dispatch(MANUAL_DOCUMENTS_CONTROLLER.doLoadVATBoxes(params));
    },
    doCreateManualDocumentLatest: (params, callback) => {
        dispatch(MANUAL_DOCUMENTS_CONTROLLER.doCreateManualDocumentLatest(params, callback))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(EnhancedVATReturns);